import nexus from '@db2b/nexus-js'
let OneSignal = window.OneSignal

const state = {
  all: [],
  current: {
    id: null,
    meta: {}
  }
}

const getters = {
  all: state => state.all,
  commercials: state => state.all.filter(user => user.roles.includes('COMMERCIAL')),
  isCurrentUserLoaded: state => state.current.id !== null,
  current: state => {
    let user = state.all.find(user => user.id === state.current.id)

    if (user) {
      user.meta = state.current.meta
    }

    return user
  }
}

const actions = {
  loadAll ({commit, state}) {
    return nexus.get('account', '/users')
      .then(response => {
        state.all = response.data.data
      })
  },
  loadCurrent ({commit}) {
    // Async load the onesignal meta
    OneSignal.getUserId(function (deviceId) {
      commit('pushCurrentUserMeta', {
        deviceId
      })
    })

    return nexus.get('account', '/users/me')
      .then(response => {
        commit('currentUserLoaded', {
          user: response.data.data
        })
      })
  }
}

const mutations = {
  currentUserLoaded (state, {user}) {
    state.current.id = user.id
  },
  pushCurrentUserMeta (state, meta) {
    state.current.meta = Object.assign({}, state.current.meta, meta)
  },
  currentUserStatisticsLoaded (state, statistics) {
    state.current.statistics = statistics
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/account/users.js